module.exports = __webpack_public_path__ + "static/img/bannerBg5.893f9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bannerBg5.png
// module id = YIZ/
// module chunks = 1